import { call, put, takeEvery } from "redux-saga/effects";
import i18next from "i18next";
import * as actionTypes from "../../constants/ActionTypes/Dashboard";
import { _CALLGETAPI } from "../../api/apiHandler";
import { _API_ENDPOINT, _BROTHER_PLUS_API_ENDPOINTS } from "../../constants/AppConstants";
import { isEnrollmentBrotherPlus } from "../../constants/AppMethod";

function _FETCHMYACCOUNTAPI(UID, deviceId) {
  const isBPlusDeviceAvailable = isEnrollmentBrotherPlus();
  const endpoint = (isBPlusDeviceAvailable)
    ? _BROTHER_PLUS_API_ENDPOINTS.GET_MY_ACCOUNT
    : _API_ENDPOINT.GET_MY_ACCOUNT;

  const payload = {
    params: {
      UserId: UID,
      deviceId: deviceId,
    },
  };
  return _CALLGETAPI(endpoint, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function* fetchMyAccount(action) {
  try {
    const deviceID = action.deviceId;
    const UID = action.UID;
    if (UID) {
      const myAccount = yield call(
        _FETCHMYACCOUNTAPI,
        UID,
        deviceID
      );
      if (myAccount) {
        yield put({
          type: actionTypes.FETCH_MY_ACCOUNT_SUCCESS,
          myAccount: myAccount,
        });
      } else {
        yield put({
          type: actionTypes.FETCH_MY_ACCOUNT_ERROR,
          message: i18next.t('ERROR_CONTENT.INFO_GENERAL'),
        });
      }
    } else {
      yield put({
        type: actionTypes.FETCH_MY_ACCOUNT_ERROR,
        message: i18next.t('ERROR_CONTENT.INFO_GENERAL')
      });
    }
  } catch (e) {
    /**
     * This conditional statement is added to avoid
     * displaying error message in view while logout from app
     */
    if (e instanceof TypeError === false && e.message !== "401") {
      yield put({
        type: actionTypes.FETCH_MY_ACCOUNT_ERROR,
        message: e.message,
      });
    }
  }
}

function* MyAccount() {
  yield takeEvery(actionTypes.FETCH_MY_ACCOUNT, fetchMyAccount);
}

export default MyAccount;
